import React, { lazy, Suspense } from "react";
import { RouteObject } from "react-router";
import { RouteLoader } from "@/shared/ui/RouteLoader";

// Lazy load workspace settings pages (accessed less frequently)
const AccountSettings = lazy(
  () => import("@/features/workspace/pages/settings/SettingsPage")
);
const AccountBillingSettings = lazy(
  () => import("@/features/workspace/pages/billing/BillingPage")
);
const AccountOrganizationsSettings = lazy(
  () => import("@/features/workspace/pages/organizations/OrganizationsPage")
);

// Eager load frequently accessed pages
import AccountMembers from "@/features/workspace/pages/members/MembersPage";
import AssessmentReport from "@/features/assessments/pages/AssessmentReportPage";

export const workspaceRoutes: RouteObject[] = [
  {
    path: "/account/:accountId",
    children: [
      {
        path: "settings",
        element: (
          <Suspense
            fallback={<RouteLoader messageKey="common.loading_settings" />}
          >
            <AccountSettings />
          </Suspense>
        ),
      },
      {
        path: "members",
        Component: AccountMembers,
      },
      {
        path: "organisations",
        element: (
          <Suspense
            fallback={<RouteLoader messageKey="common.loading_settings" />}
          >
            <AccountOrganizationsSettings />
          </Suspense>
        ),
      },
      {
        path: "billing",
        element: (
          <Suspense
            fallback={<RouteLoader messageKey="common.loading_settings" />}
          >
            <AccountBillingSettings />
          </Suspense>
        ),
      },
      {
        path: "person/:personId/assessment/:assessmentId/report",
        Component: AssessmentReport,
      },
    ],
  },
];
